import { useQuery } from "@tanstack/react-query";
import { section } from "./query";
import { PostModel } from "common/models/BaseModel";
import { ISectionGridFilter } from "./types";

export function GetSections(model: PostModel<ISectionGridFilter> | undefined) {
  return useQuery(section.list(model));
}

export function GetSection(Id: string | number) {
  return useQuery({
    ...section.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetSectionValues() {
  return useQuery(section.getSectionValues());
}

export function GetSectionView(id: string | number | undefined, isOpen: boolean) {
  return useQuery({
    ...section.getViewById(id || ""),
    enabled: Boolean(id) && isOpen,
  });
}
